// src/layouts/PublicLayout.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectIsAuthenticated, selectAwaitingVerification } from '../store/slices/authSlice';

export const PublicLayout = () => {
  const location = useLocation();
  const isDarkMode = useSelector(state => state.ui.isDarkMode);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isAwaitingVerification = useSelector(selectAwaitingVerification);

  // 🔐 RULE 1: If user is awaiting verification and NOT already on /verify, force them there
  // This prevents redirect loops when LoginPage tries to send user to /verify
  if (isAwaitingVerification && location.pathname !== '/verify') {
    return <Navigate to="/verify" replace />;
  }
  
  // 🔐 RULE 2: If user is fully authenticated, redirect them away from public pages (login, verify)
  // Authenticated users shouldn't see login page
  if (isAuthenticated && !isAwaitingVerification) {
    return <Navigate to="/dashboard" replace />;
  }

  // ✅ All checks passed, render the public page (login, verify, go, error pages)
  return (
    <div className={`min-h-screen flex items-center justify-center  
                     bg-gray-50 ${isDarkMode ? 'dark' : ''}`}>
      <Outlet />
    </div>
  );
};

